import React, { Component } from 'react';
import { Card, CardBody, Row, Col, Button, Spinner, Modal, ModalBody, ModalHeader, Label, FormGroup, Input } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";

import SweetAlert from "react-bootstrap-sweetalert";

import { BaseUrl } from "../../helpers/Baseurl"
//Import Breadcrumb

import BootstrapTable from "react-bootstrap-table-next";

class Menu extends Component {
  constructor(props) {
      super(props);
      this.state = {
          menue:[],
          selected_menue:null
          
      }
      this.handleEditMenuesubmit = this.handleEditMenuesubmit.bind(this)
      this.handleMenueSubmit = this.handleMenueSubmit.bind(this)
      this.tog_add_meal = this.tog_add_meal.bind(this)
      this.tog_edit_meal = this.tog_edit_meal.bind(this)

  }

  async componentDidMount() {
    await this.loadMenueData()
  }

  tog_add_meal() {
    this.setState(prevState => ({
      model_add_meal: !prevState.model_add_meal
    }));
    this.removeBodyCss();
  }

  tog_edit_meal() {
    this.setState(prevState => ({
      model_edit_meal: !prevState.model_edit_meal
    }));
    this.removeBodyCss();
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
    

    
  async loadMenueData(){
      const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
          };
      await fetch(`${BaseUrl}/api/hotels/hotel-menue/?size=50&hotel__id=${this.props.hotel.id}`,requestOptions)
          .then(res => res.json())
          .then(
              (data) => {
                  
                  this.setState({ menue: data.results, loading:false, selected_menue:null })
                      },
                  
              (error) => {
                  console.log(error, 'error------') 
              }
          )  
  }

  handleDeleteIncludeRow(selected_menue){
    
    const requestOptions = {
        method: 'DELETE',
    headers: { 'Authorization': `Bearer ${this.props.access}`, },
    };
    fetch(`${BaseUrl}/api/hotels/hotel-menue/${selected_menue.id}/`,requestOptions)
        .then(res => 
            {if(res.status >= 400){
                console.log("error")
            }
            else{
                this.loadMenueData()
                this.setState({
                    selected_menue:null,
                    success_confirm: true,
                    alert_confirm : false,
                    dynamic_title: "Deleted!",
                    dynamic_description: "Row has been deleted."
                })
            }
        }
    )
  

  }

  handleEditMenuesubmit(e, values){
    const { selected_menue } = this.state
    this.setState({loading:true})
    let items = document.getElementById("edit_menue_items").value
    let menuedata = {"meal": values.meal, "hotel": this.props.hotel.id, 'items':items}
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
      body: JSON.stringify(menuedata)
      };
      fetch(`${BaseUrl}/api/hotels/hotel-menue/${selected_menue.id}/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                  this.loadMenueData()
                  this.tog_edit_meal()
                    
                }
                else{
                  this.loadMenueData()
                  this.tog_edit_meal()  
                }    
            }
        )
  }
    

  handleMenueSubmit(e, values){
    this.setState({ loading:true})
    let items = document.getElementById("menue_items").value
    let menuedata = {"meal": values.meal, "hotel": this.props.hotel.id, 'items':items}
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.props.access}`, },
      body: JSON.stringify(menuedata)
      };
      fetch(`${BaseUrl}/api/hotels/hotel-menue/`,requestOptions)
            .then(res => 
                {if(res.status >= 400){
                  this.loadMenueData()
                  this.tog_add_meal()
                    
                }
                else{
                  this.loadMenueData()
                  this.tog_add_meal()  
                }    
            }
        )
  }

  render() {
    const { selected_menue } = this.state
      const GuidelineColumn = [
          {
              dataField: "id",
              text: "id",
              hidden: true,
          },
          
          {
              dataField: "meal",
              text: "Meal",
              headerStyle: { backgroundColor: '#fcb92c', },
          },
          {
            dataField: "items",
            text: "Items",
            headerStyle: { backgroundColor: '#fcb92c',  },
        },
          
          {
              dataField: "menu",
              isDummyField: true,
              text: "Action",
              editable: false,
              headerStyle: { backgroundColor: '#fcb92c', width: '15%' },
              formatter: (cellContent, row, col) => 
              { 
                  return (
                      <React.Fragment>
                        <Link to="#" onClick={()=> {this.setState({selected_menue:row});this.tog_edit_meal()}} className="text-primary me-2"><i className="mdi mdi-pencil font-size-18"></i></Link>                    
                        <Link to="#" onClick={() => this.setState({ selected_menue: row, alert_confirm:true  })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>                    
                      </React.Fragment>
                    )
        
              }
            },
          ]
                
      return (
          <React.Fragment>
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                <h4 className="card-title">Menue</h4>
                  <BootstrapTable
                      keyField="id"
                      data={this.state.menue}
                      columns={GuidelineColumn}
                      
                    />
                  
                  <div style={{textAlign: "center"}}>
                      <Button color="secondary" outline className="waves-effect me-1 mb-3 "  onClick={this.tog_add_meal}>
                          Add Meal
                      </Button>
                  </div>

                </CardBody>
              </Card>
            </Col>
            
          </Row>
          {/* Add Menue Meal */}
          <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_add_meal}
                toggle={this.tog_add_meal}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_add_meal: false })}>
                Add Meal
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleMenueSubmit} >
          
                    <Row>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="meal">Meal</Label>
                          <AvField
                            name="meal"
                            placeholder="Meal"
                            type="text"
                            errorMessage="Enter Meal"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="meal"
                            
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="menue_items">Items</Label>
                        <Input
                            type="textarea"
                            id="menue_items"
                            rows="3"
                            // defaultValue={hotel.description}
                            placeholder="Menue"
                        />
                    </div>
                  </Row> 
                                      
                    <FormGroup className="mb-0">
                      {this.state.loading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
            {/* Edit Menue Meal */}
            <Col sm={6} md={4} xl={3} className="mt-4">
              
              <Modal
                isOpen={this.state.model_edit_meal}
                toggle={this.tog_edit_meal}
                centered={true}
              >
                <ModalHeader toggle={() => this.setState({ model_edit_meal: false })}>
                Edit {selected_menue?.meal} Meal
                </ModalHeader>
                <ModalBody>
                  <AvForm className="needs-validation" onValidSubmit={this.handleEditMenuesubmit} >
          
                    <Row>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label className="form-label" htmlFor="edit_meal">Meal</Label>
                          <AvField
                            name="meal"
                            placeholder="Meal"
                            type="text"
                            errorMessage="Enter Meal"
                            value = {selected_menue?.meal}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="edit_meal"
                            
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="edit_menue_items">Items</Label>
                        <Input
                            type="textarea"
                            id="edit_menue_items"
                            rows="3"
                            defaultValue={selected_menue?.items}
                            placeholder="Items"
                        />
                    </div>
                  </Row> 
                                      
                    <FormGroup className="mb-0">
                      {this.state.loading?(
                        <Spinner className="me-2 mt-2" color="primary" />
                      ):(
                        <div>
                    
                      <Button type="submit" color="primary" className="me-1">
                        Submit
                      </Button>
                      </div>
                        )}
                    </FormGroup>     
                  </AvForm>

                </ModalBody>
              </Modal>
            </Col>
            {this.state.alert_confirm ? (
                  <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.handleDeleteIncludeRow(this.state.selected_menue)}
                  onCancel={() =>
                      this.setState({
                          alert_confirm: false,
                          selected_menue:null,
                      })
                  }
                  >
                  You won't be able to revert this!
                  </SweetAlert>
                  ) : null}

                  {this.state.success_confirm ? (
                  <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                  >
                      {this.state.dynamic_description}
                  </SweetAlert>
                  ) : null
            }
    
    </React.Fragment>
      );
  }
}

export default Menu;
